/** @module general */

/**
 * Allgemeine Funktionalität
 *
 */
export class OpaccGeneral {
	constructor() {
	}

	attachEventListener() {
	}
}